import { sendAxonEvent } from 'helpers/sendAxonEvent'
import { stripCohortSuffix } from 'helpers/stripCohortSuffix'
import { useEffect } from 'react'
import { useZustandStore } from 'zustandGlobalStore'

export const useManualPageViewTracker = (): void => {
  const currentPageId = useZustandStore((state) => state.currentPageId)
  const leadId = useZustandStore((state) => state.lead?.id || '')

  useEffect(() => {
    if (!currentPageId) return
    const cleanName = stripCohortSuffix(currentPageId)

    window.fbq?.(
      'track',
      'PageView',
      { step_name: cleanName },
      { eventID: `pv-${leadId}-${cleanName}` },
    )
    sendAxonEvent('page_view', { step_name: cleanName })
  }, [currentPageId, leadId])
}
